import React from 'react'

export const EmergenceAnimationNew = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img loading='lazy' src='/public/img/new-emergence-logo-white.gif' alt='Loading...' {...props} />
)
